/* Global Theme Object */
window.theme = window.theme || {};

theme.updateCartCount = function() {
  fetch('/cart.js')
    .then(r => r.json())
    .then(c => {
      document.querySelectorAll('[data-cart-count]').forEach(e => {
        e.textContent = c.item_count;
      });
    });
};

theme.attachCartEvents = function() {
  const cd = document.getElementById('CartDrawer');
  if (!cd) return;

  cd.querySelectorAll('[data-qty-change]').forEach(b => {
    b.addEventListener('click', function() {
      const itemRow = this.closest('[data-line]');
      if (!itemRow) return;
      
      const line = itemRow.dataset.line;
      let qty = parseInt(itemRow.querySelector('.quantity-selector__input').value);
      const action = this.dataset.qtyChange;

      if (action === 'plus') qty++;
      else if (action === 'minus') qty--;
      else if (action === 'remove') qty = 0;

      if (qty < 0) qty = 0;

      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty })
      }).then(() => theme.refreshCart());
    });
  });

  const closeBtn = cd.querySelector('[data-cart-drawer-close]');
  if (closeBtn) closeBtn.addEventListener('click', theme.closeCart);
};

theme.refreshCart = function() {
  const cd = document.getElementById('CartDrawer');
  if (!cd) return;

  fetch('/?sections=cart-drawer')
    .then(r => r.json())
    .then(j => {
      const html = new DOMParser().parseFromString(j['cart-drawer'], 'text/html');
      const newContent = html.getElementById('CartDrawer');
      if (newContent) {
        cd.innerHTML = newContent.innerHTML;
        theme.attachCartEvents();
        theme.updateCartCount();
      }
    });
};

theme.openCart = function() {
  const cd = document.getElementById('CartDrawer');
  const co = document.getElementById('CartDrawerOverlay');
  if (cd && co) {
    cd.classList.add('is-open');
    co.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    theme.refreshCart();
  }
};

theme.closeCart = function() {
  const cd = document.getElementById('CartDrawer');
  const co = document.getElementById('CartDrawerOverlay');
  if (cd && co) {
    cd.classList.remove('is-open');
    co.classList.remove('is-open');
    document.body.style.overflow = '';
  }
};

document.addEventListener('DOMContentLoaded', function() {
  /* Header Logic */
  var h = document.querySelector('[data-header]');
  if (h) {
    var ly = 0, tk = false, he = document.querySelector('[data-hero]'), ih = !!he, th = ih ? window.innerHeight * .15 : 100;
    function u() {
      var y = window.scrollY, d = y - ly;
      if (ih) {
        if (y < th) {
          h.classList.add('header--transparent');
          h.classList.remove('header--hidden');
        } else {
          h.classList.remove('header--transparent');
          if (d > 4) h.classList.add('header--hidden');
          else if (d < -4) h.classList.remove('header--hidden');
        }
      } else {
        if (y > th) {
          if (d > 4) h.classList.add('header--hidden');
          else if (d < -4) h.classList.remove('header--hidden');
        } else h.classList.remove('header--hidden');
      }
      ly = y;
      tk = false;
    }
    window.addEventListener('scroll', function() {
      if (!tk) {
        tk = true;
        requestAnimationFrame(u);
      }
    }, { passive: true });
    if (ih && window.scrollY < th) h.classList.add('header--transparent');
  }

  /* Mobile Menu */
  var mt = document.querySelector('[data-menu-toggle]'), 
      mm = document.querySelector('[data-mobile-menu]'), 
      mc = document.querySelector('[data-mobile-menu-close]'),
      mo = document.getElementById('MobileMenuOverlay'),
      mi = document.querySelector('[data-menu-icon]'), 
      ci = document.querySelector('[data-close-icon]');

  function openMobileMenu() {
    mm.classList.add('is-open');
    if (mo) mo.classList.add('is-open');
    if (mi) mi.style.display = 'none';
    if (ci) ci.style.display = 'block';
    document.body.style.overflow = 'hidden';
  }

  function closeMobileMenu() {
    mm.classList.remove('is-open');
    if (mo) mo.classList.remove('is-open');
    if (mi) mi.style.display = 'block';
    if (ci) ci.style.display = 'none';
    document.body.style.overflow = '';
  }

  if (mt && mm) {
    mt.addEventListener('click', function() {
      if (mm.classList.contains('is-open')) closeMobileMenu();
      else openMobileMenu();
    });
    if (mo) mo.addEventListener('click', closeMobileMenu);
    if (mc) mc.addEventListener('click', closeMobileMenu);
  }

  /* Mega Menu */
  var triggers = document.querySelectorAll('[data-mega-menu-trigger]');
  triggers.forEach(function(tr) {
    var mgId = tr.getAttribute('data-mega-menu-trigger');
    var mg = document.getElementById(mgId);
    if (mg) {
      var to;
      var s = function() { clearTimeout(to); mg.classList.add('is-open'); };
      var hi = function() { to = setTimeout(function() { mg.classList.remove('is-open'); }, 200); };
      tr.addEventListener('mouseenter', s);
      tr.addEventListener('mouseleave', hi);
      mg.addEventListener('mouseenter', s);
      mg.addEventListener('mouseleave', hi);
    }
  });


  /* Cart Triggers */
  document.querySelectorAll('[data-cart-drawer-trigger]').forEach(b => {
    b.addEventListener('click', e => { e.preventDefault(); theme.openCart(); });
  });
  const co = document.getElementById('CartDrawerOverlay');
  if (co) co.addEventListener('click', theme.closeCart);

  /* Quick Add */
  document.querySelectorAll('[data-add-to-cart]').forEach(b => {
    b.addEventListener('click', function(e) {
      e.preventDefault();
      var v = this.dataset.variantId, s = this;
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: v, quantity: 1 })
      }).then(r => {
        if (r.ok) {
          theme.openCart();
          s.textContent = 'Added!';
          setTimeout(() => { s.textContent = 'Quick Add'; }, 2000);
        }
      });
    });
  });

  /* Product Card Slider */
  document.querySelectorAll('[data-product-card]').forEach(c => {
    var im = c.querySelectorAll('[data-product-image]');
    if (im.length <= 1) return;
    var i = 0, p = c.querySelector('[data-arrow-prev]'), n = c.querySelector('[data-arrow-next]');
    function sh(x) { im.forEach((m, j) => { m.style.display = j === x ? 'block' : 'none'; }); }
    if (p) p.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); i = (i - 1 + im.length) % im.length; sh(i); });
    if (n) n.addEventListener('click', e => { e.preventDefault(); e.stopPropagation(); i = (i + 1) % im.length; sh(i); });
    sh(0);
  });

  /* Search Logic (Roll-down System) */
  (function() {
    const mobileSearchRoll = document.querySelector('[data-mobile-search-roll]');
    const mobileSearchInput = document.querySelector('[data-mobile-search-input]');
    const mobileSearchClose = document.querySelector('[data-mobile-search-close]');
    const searchTriggers = document.querySelectorAll('[data-search-trigger]');
    
    const desktopSearchBar = document.querySelector('[data-search-bar]');
    const desktopSearchInput = document.querySelector('[data-search-input]');
    const desktopSearchClose = document.querySelector('[data-search-close]');

    function openSearch(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      
      if (window.innerWidth < 768) {
        if (mobileSearchRoll) {
          mobileSearchRoll.classList.add('is-open');
          if (mobileSearchInput) setTimeout(() => mobileSearchInput.focus(), 300);
        }
      } else {
        if (desktopSearchBar) {
          desktopSearchBar.classList.add('is-open');
          if (desktopSearchInput) setTimeout(() => desktopSearchInput.focus(), 100);
        }
      }
    }

    function closeSearch() {
      if (mobileSearchRoll) mobileSearchRoll.classList.remove('is-open');
      if (desktopSearchBar) desktopSearchBar.classList.remove('is-open');
      document.querySelectorAll('[data-search-results]').forEach(r => r.classList.remove('is-active'));
    }

    function debounce(fn, wait) {
      let t;
      return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    }

    async function doSearch(q, container) {
      if (!q || q.length < 2) {
        container.classList.remove('is-active');
        return;
      }

      try {
        const response = await fetch(`/search/suggest.json?q=${encodeURIComponent(q)}&resources[type]=product&resources[limit]=5&section_id=header`);
        const data = await response.json();
        const products = data.resources.results.products;

        if (products && products.length > 0) {
          let html = '';
          products.forEach(p => {
            html += `
              <a href="${p.url}" class="search-result-item">
                <img src="${p.image}" class="search-result-item__image" alt="${p.title}">
                <div class="search-result-item__info">
                  <h4 class="search-result-item__title">${p.title}</h4>
                  <span class="search-result-item__price">${p.price}</span>
                </div>
              </a>
            `;
          });
          container.innerHTML = html;
          container.classList.add('is-active');
        } else {
          container.innerHTML = '<div class="search-results__empty">Keine Produkte gefunden</div>';
          container.classList.add('is-active');
        }
      } catch (e) {
        console.error('Search error:', e);
      }
    }

    const handleInput = debounce((e) => {
      const q = e.target.value;
      const container = e.target.closest('form').querySelector('[data-search-results]');
      if (container) doSearch(q, container);
    }, 300);

    if (mobileSearchInput) mobileSearchInput.addEventListener('input', handleInput);
    if (desktopSearchInput) desktopSearchInput.addEventListener('input', handleInput);

    // Prevent form redirect if input is empty or if we want to force overlay usage
    document.querySelectorAll('.search-bar__form, .mobile-search-roll__form').forEach(f => {
      f.addEventListener('submit', (e) => {
        const input = f.querySelector('input');
        if (!input || !input.value.trim()) {
          e.preventDefault();
        }
      });
    });

    searchTriggers.forEach(t => {
      t.addEventListener('click', openSearch);
    });

    if (mobileSearchClose) mobileSearchClose.addEventListener('click', closeSearch);
    if (desktopSearchClose) desktopSearchClose.addEventListener('click', closeSearch);

    // Close on scroll
    let lastScrollY = window.scrollY;
    window.addEventListener('scroll', () => {
      if (Math.abs(window.scrollY - lastScrollY) > 50) {
        closeSearch();
        lastScrollY = window.scrollY;
      }
    }, { passive: true });

    // Close on click outside
    document.addEventListener('click', (e) => {
      if (mobileSearchRoll && mobileSearchRoll.classList.contains('is-open')) {
        if (!mobileSearchRoll.contains(e.target) && ![...searchTriggers].some(t => t.contains(e.target))) {
          closeSearch();
        }
      }
      if (desktopSearchBar && desktopSearchBar.classList.contains('is-open')) {
        if (!desktopSearchBar.contains(e.target) && ![...searchTriggers].some(t => t.contains(e.target))) {
          closeSearch();
        }
      }
    });
  })();

  /* Initial Cart Setup */
  theme.updateCartCount();
  theme.attachCartEvents();
});



